/**
 * The wire's map handoff on one socket (ADR-106 decisions 19 and 20, PROTOCOL.md 6.91.0): the bounds of
 * `handoffInitiated`, the map a respawn point names and the map `welcome` names, and how a page reads a `welcome` that
 * names none.
 */

/**
 * The longest map id `handoffInitiated` and `welcome` carry, in UTF-16 units; a map id is never empty on the wire.
 */
export const MAX_HANDOFF_MAP_CHARS = 64;

/**
 * The longest display name of the target map `handoffInitiated` carries; empty for a map with no name.
 */
export const MAX_HANDOFF_NAME_CHARS = 48;

/**
 * The longest display name of the map a respawn point stands on; empty or absent for the map the offer is sent on.
 */
export const MAX_RESPAWN_POINT_MAP_CHARS = 48;

/**
 * Why a handoff moves a character: a death return to a shrine on another map, or a walk through a door or other
 * crossing.
 */
export const HANDOFF_CAUSES = ["death", "travel"] as const;
export type HandoffCause = (typeof HANDOFF_CAUSES)[number];

/**
 * The map a `welcome` without `map` names: every server before 6.91.0 ran the one map `main`.
 */
export const WELCOME_DEFAULT_MAP = "main";

/**
 * The map a parsed `welcome` stands the character on.
 *
 * @param welcome The welcome's fields, as `parseTextFrame` returned them.
 * @returns Its `map`, or `WELCOME_DEFAULT_MAP` when it carries none.
 */
export function welcomeMap(welcome: Readonly<Record<string, unknown>>): string {
  const map = welcome["map"];
  return typeof map === "string" && map.length > 0 ? map : WELCOME_DEFAULT_MAP;
}
